module.exports = __webpack_public_path__ + "static/media/agora.fe5bc93e.svg";